import React from 'react'

import { DateObject } from '../../helpers/date'
import { Attempt } from '../../types/inventoryAllocationLogs'
import AttemptRow from './AttemptRow'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AttemptBoxProps {
  attempt: Attempt
  selectedDateInDatePicker: DateObject
}

const AttemptBox: React.FC<AttemptBoxProps> = ({
  attempt,
  selectedDateInDatePicker
}) => {
  const classes = useStyles()

  return (
    <div className={classes.paper}>
      <div>
        <AttemptRow
          dailyLogAllocations={attempt.dailyAllocationDetails}
          attemptDate={attempt.time.slice(0, 10)}
          attemptTime={attempt.time.slice(11, 16)}
          name={attempt.name}
          userEmail={attempt.userEmail}
          selectedDateInDatePicker={selectedDateInDatePicker}
          attemptID={attempt.attemptId}
        />
      </div>
    </div>
  )
}

export default AttemptBox
